import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Icon, Button, Checkbox, TextField, IconButton } from "@mui/material";
import "./FieldWorkers.css";
import SelectDropdown from "../SidebarPathTraversal/SelectDropdown";
import {
  selectWorkerZone,
} from "../../redux/reducers/fieldMembers";
import Translate from "../Translate/Translate";
import AddModal from "../AddModal/AddModal";
import helperFunctions from "../../utils/helper";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  deleteFieldMembers,
  fetchFieldMembersSuccess,
  selectFieldMembers,
  updatefieldMember
} from "../../redux/reducers/fieldMembers";
import { useAuth0 } from "@auth0/auth0-react";
import { toast } from "react-hot-toast";

const TableComponent = () => {
  const selectAllOptions = process.env.REACT_APP_ALL_SELECT_OPTION;

  const tableData = useSelector((state) => state.fieldMembers.data); // Assuming 'tableData' is stored in the Redux store

  const selectedWorkersZone = useSelector(
    (state) => state.fieldMembers.selectedWorkerZone
  )


  const user = useSelector((state) => state.user);

  const zones = useSelector((state) => state.fieldMembers.workerZone); // Assuming 'tableData' is stored in the Redux store

  const dispatch = useDispatch();


  const [zonesDropdownVisibility, setZonesDropdownVisibility] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalHeader, setmodalHeader] = useState("Enter New Member Details");
  const [type, setType] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [fieldmember, setfieldmember] = useState({});
  const { getAccessTokenSilently } = useAuth0();

  const columns = [
    {
      width: 12,
      label: "First Name",
      dataKey: "first_name",
      dataType: "text",
    },
    {
      width: 12,
      label: "Last Name",
      dataKey: "last_name",
      dataType: "text",
    },
    {
      width: 12,
      label: "Employee ID",
      dataKey: "employee_id",
      dataType: "bigint",
    },
    {
      width: 12,
      label: "Phone No.",
      dataKey: "phone_num",
      dataType: "double precision",
    },
    {
      //width: 15,
      width: 12,
      label: "Zone",
      dataKey: "zone",
      dataType: "text",
    },
    {
      width: 8,
      label: "Edit",
      dataKey: "edit",
      dataType: "icon",
      padding: "1rem",
    },
    {
      width: 8,
      label: "Delete",
      dataKey: "delete",
      dataType: "icon",
      padding: "1rem",
    },
  ];

  const filterConfig = [
    {
      name: "Worker ID",
      type: "ID",
      filterType: "search",
    },
    {
      name: "ZONE",
      type: "zone",
    },
  ];

  const handleDropdownClick = (configType) => {
    console.log("configType ", configType, " handleDropdownClick ")
    if (configType === "zone") {
      setZonesDropdownVisibility(!zonesDropdownVisibility);
    }
  };


  const handleZoneClick = (zone) => {
    if (zone === selectAllOptions){
      const curValue = selectedWorkersZone[zone]
      const tempObj = {};
      for (let key in selectedWorkersZone) {
        tempObj[key] = !curValue;
      }
      dispatch(selectWorkerZone(tempObj));
    }else{
      
    const tempObj = {};
    tempObj[zone] = true;

    if (selectedWorkersZone[zone] === null || selectedWorkersZone[zone] === true) {
      tempObj[zone] = false;
    }

    dispatch(selectWorkerZone(tempObj));
    }
  }

  const handleSearchInput = (val) => {
    setSearchInput(val);
  };

  const dropdownRefs = useRef([]);

  const handleCloseDropdownRef = (dropdown, index) => {
    console.log("handleCloseDropdownRef", dropdown)
    console.log(dropdownRefs)
    return (e) => {
      // alert("this is dropdown blur --- "+ dropdown+ index)
      if (dropdownRefs.current[index].contains(e.relatedTarget)) {
        return;
      }

      handleDropdownClick(dropdown)
    };
  };

  const deleteFieldMemberAPI = async (employee_id, callback) => {

    const accessToken = await getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      },
    });

    const url =
      process.env.REACT_APP_API_BASE_URL + `/delete_worker/${employee_id}`;

    const authToken = accessToken; // Replace with your actual authorization token

    fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // Process the retrieved data here   
        callback(data);
      })
      .catch((error) => {
        // Handle any errors that occurred during the request
        console.error("Error: Something went wrong", error);
      });
  };

  const deleteFieldMember = (emp_id) => {
    // Show a loading toast
    const toastId = toast.loading("Deleting Field Member...");
  
    deleteFieldMemberAPI(emp_id, (data) => {
      // Dismiss the loading toast
      toast.dismiss(toastId);
  
      // Show a success toast
      toast.success("Field Member Deleted Successfully!");
  
      // Update Redux store
      dispatch(deleteFieldMembers(emp_id));
  
      console.log("Member Deleted Successfully");
    }).catch((error) => {
      // Dismiss the loading toast
      toast.dismiss(toastId);
  
      // Show an error toast
      toast.error("Failed to delete Field Member. Please try again!");
      console.error(error);
    });
  };
  

  return (
    <div className="table-container">
      <div className="filters-section">
        <div className="filters-left-section">
          {filterConfig.map((config, index) => (
            <div className="filters-button-container"
              onBlur={handleCloseDropdownRef(config.type, index)}
              ref={(el) => (dropdownRefs.current[index] = el)} // Set a ref to the first dropdown
              tabIndex={80 + index}
            >
              <h5 className="filters-dropdown-label">
                <Translate text={config.name} />
              </h5>

              {config.filterType === "search" ? (
                <div className="search-site-id">
                  <TextField
                    id="search-site-id"
                    placeholder={user.language !== "hi" ? "Search by Worker ID" : "कर्मचारी आईडी से खोजें"}
                    type="search"
                    fullWidth
                    defaultValue=""
                    focused
                    onInput={(evt) => handleSearchInput(evt.target.value)}
                    InputProps={
                      <Icon
                        baseClassName="fas"
                        className={"fa fa-magnifying-glass"}
                        fontSize="small"
                        color="var(--secondary-text-color)"
                        style={{ color: "var(--secondary-text-color)" }}
                      />
                    }
                  />
                </div>
              ) : (
                <div className="filters-dropdown-sub-container">
                  <div
                    className="filter-dropdown-selected-label"
                    onClick={() => handleDropdownClick(config.type)}
                  >
                    <p>
                      <Translate text={"Selected"} />
                    </p>

                    <Icon
                      baseClassName={"fas"}
                      className={"cursor-pointer fa-caret-down"}
                      fontSize="small"
                    />
                  </div>

                  <div>
                    <div
                      className={
                        "status-select-dropdown" +
                        (
                          (config.type === "zone" && zonesDropdownVisibility)
                            ? ""
                            : " hide") +
                        (config.type === "zone"
                          ? " zone-filter-dropdown-container"
                          : "")
                      }
                    >
                      {config.type === "zone" &&
                        zones.map((zone) => {
                          return (
                            <div
                              className="site-info-status-select-sub-container cursor-pointer"
                              style={{ color: zone.color }}
                              onClick={() => handleZoneClick(zone)}
                            >
                              <Checkbox
                                onChange={(evt) =>
                                  handleZoneClick(
                                    selectedWorkersZone[zone],
                                    zone
                                  )
                                }
                                checked={selectedWorkersZone[zone] === true}
                              />

                              <p className="m-0" style={{ flexGrow: 1 }}>
                                <Translate text={zone} />
                              </p>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Table starts from here */}
      <div className="table-sub-container">
        <div className="row table-header">
          {columns.map((val) => (
            <div
              style={{
                width: val.width + "%",
                maxWidth: val.width + "%",
                overflow: "hidden",
              }}
            >
              <h4>
                <Translate text={val.label} />
              </h4>
            </div>
          ))}
        </div>

        <div className="data-row-container">
          {tableData.map((data, index) => {
            if (
              selectedWorkersZone[data.zone] &&
              (searchInput === "" ||
                data?.employee_id
                  .toString()
                  .toLowerCase()
                  .includes(searchInput.toLowerCase()))
            ) {
              return (
                <div className="row data-row" key={index}>
                  {columns.map((column) =>
                    column.dataType === "icon" && column.dataKey === "edit" ? (
                      <div
                        className="m-0"
                        style={{
                          width: column.width + "%",
                          justifyContent: "space-around",
                          display: "flex",
                        }}
                      >
                        <IconButton
                          className="editIcon"
                          aria-label="EditIcon"
                          onClick={() => {
                            setShowModal(true);
                            setmodalHeader("Update Member Details");
                            setType("update");
                            setfieldmember({
                              first_name: data.first_name,
                              last_name: data.last_name,
                              employee_id: data.employee_id,
                              zone: data.zone,
                              phone_num: data.phone_num,
                            });
                          }}
                          style={{ color: "green" }}
                        >
                          <EditIcon />
                        </IconButton>
                      </div>
                    ) : column.dataType === "icon" && column.dataKey === "delete" ? (
                      <div
                        className="m-0"
                        style={{
                          width: column.width + "%",
                          justifyContent: "space-around",
                          display: "flex",
                        }}
                      >
                        <IconButton
                          className="deleteIcon"
                          aria-label="DeleteIcon"
                          onClick={() => {
                            deleteFieldMember(data.employee_id);
                            // dispatch(deleteFieldMembers(data.employee_id));
                          }}
                          style={{ color: "red" }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </div>
                    ) : (
                      <p
                        className="m-0"
                        style={{
                          width: column.width + "%",
                          maxWidth: column.width + "%",
                        }}
                      >
                        <Translate text={data[column.dataKey]} />
                      </p>
                    )
                  )}
                </div>
              );
            }
          })}

        </div>
      </div>

      {/* Add Field Member Icon */}
      <div
        className="add-circle-container"
        style={{
          position: "absolute",
          top: "2rem",
          right: "7rem",
        }}
        onClick={() => {
          setShowModal(true)
          setType("")
          setmodalHeader("Enter New Member Details")
        }}
      >
        <Icon
          baseClassName="fas"
          className="fa fa-plus"
          fontSize="medium"
        />
      </div>
      {showModal && (
        <div className="modal-container">
          <AddModal
            fieldMembersdata={fieldmember}
            modaltypes={type}
            showModal={showModal}
            setShowModal={setShowModal}
            modalHeader={modalHeader}
          />
        </div>
      )}
    </div>

  );
};

export default TableComponent;
